import { z } from 'zod';
import { scaleOptionSchema } from './create-scale.js';

export const updateScaleParamsSchema = z.object({
  scale_id: z.uuid('Invalid scale ID'),
});

export const updateScaleSchema = z.object({
  code: z.string().min(1, 'Code is required').max(255, 'Code must be less than 255 characters').optional(),
  label: z.string().min(1, 'Label is required').max(255, 'Label must be less than 255 characters').optional(),
  options: z
    .array(scaleOptionSchema)
    .min(2, 'At least 2 options are required')
    .refine(
      (options) => {
        const values = options.map((opt) => opt.value);
        return new Set(values).size === values.length;
      },
      { message: 'All option values must be unique' },
    )
    .optional(),
});

export type UpdateScaleParamsPayload = z.infer<typeof updateScaleParamsSchema>;
export type UpdateScalePayload = z.infer<typeof updateScaleSchema>;
